<div class="titleBox"> <h1 style="text-align: center">Plans</h1></div>
<div><hr></div>
<br>

<div style="display: flex;">
  <div class='my-alternate-theme' style="width:50%">
    <h4 style="font-size: 16px;
    margin-top: 1em;">Deep Searches: <button class="clearSearchButton" (click)="reset()">Clear</button> </h4>
  
  <form [formGroup] = "form" style="margin-top: 2em;">
  
  
  <div>
    <mat-form-field style="width:80%">
      <mat-label>Bedrooms:</mat-label>
      <input  #safilt matInput formControlName = "bedfilter" (input)="onFilterChange($event)">
      </mat-form-field>
  </div>
  <div>
    <mat-form-field style="width:80%">
  
      <mat-label>Total Area:</mat-label>
      <input  #subfilt matInput formControlName = "areafilter" (input)="onFilterChange($event)">
      </mat-form-field>
  </div>
  <div>
    <mat-form-field style="width:80%">
  
      <mat-label>Total Volume:</mat-label>
      <input  #subfilt matInput formControlName = "volumefilter" (input)="onFilterChange($event)">
      </mat-form-field>
  </div>
  <div>
    <mat-form-field style="width:80%">
  
      <mat-label>Plan Notes:</mat-label>
      <input  #subfilt matInput formControlName = "notefilter" (input)="onFilterChange($event)">
      </mat-form-field>
  </div>
  <div>
    <mat-form-field style="width:80%">
  
      <mat-label>Plan Name:</mat-label>
      <input  #subfilt matInput formControlName = "namefilter" (input)="onFilterChange($event)">
      </mat-form-field>
  </div>
    </form>
  </div>
  
  </div>
<br>
<button class="buttonAddNew" mat-raised-button (click)="newPlan()"> Add New Plan</button>
      <ngx-table [configuration] = "configuration"  [data]="plan$ | async" [columns]="columns" [loadingTemplate] = "loadingTemplate" >
          <ng-template let-row let-index="index">

            <td>
              <div>
                <button button mat-raised-button color="green" (click)="openDialog(row)">
                  <fa-icon [icon]="faedit"></fa-icon>
                </button>
              </div>

              <div>
                <button mat-button color="warn" (click)="deleteDialog(row)">
                  <fa-icon [icon]="fatrash"></fa-icon>
                </button>
               </div>

              <div *ngIf="row.drivelink">
                <a target="_blank" [href]=gotoGDrive(row) >
                    <button  button mat-raised-button color="">
                        <fa-icon [icon]="fagoogle"  style= 'color:lightskyblue'></fa-icon>
                    </button>
                </a>
              </div>

              <div *ngIf="!row.drivelink">
                    <button  button mat-raised-button color="" (click)="addDriveFolder(row, index)">
                        <fa-icon [icon]="fagoogle"  style= 'color:red'></fa-icon>
                    </button>
              </div>

              <div>
                <button mat-button color="white" (click)="copyPlan(row)" title="Clone" style="color: lightgrey">
                 <span color="lightgrey"> <fa-icon [icon]="faclone"></fa-icon></span>
                </button>
               </div>

            </td>


            <td>
              <div>
                {{row.plan_family}}
              </div>
            </td>

            <td>
                <div>
                  {{row.plan_name}}
                  <div *ngIf="row.base_plan"><a [href]="gotobaseplan(row)" target = "_blank">
                    <fa-icon style="color: rgb(0, 0, 0)" title="View Base Plan" [icon]="faclipboard"></fa-icon>
                    </a>
                  </div>
                </div>
            </td>

            <td>
              <div>
                {{row.customer_name}}
              </div>
            </td>

            <td>
              <div>
                {{row.plan_notes}}
              </div>
            </td>

            <td>
              <div>
                {{row.bedrooms}}
              </div>
            </td>

            <td>
              <div>
                {{row.bathrooms}}
              </div>
            </td>

            <td>
              <div>
                {{row.totalarea}}<small style="padding-left: 2px">ft</small>
              </div>
            </td>

            <td>
              <div>
                {{  ( ( parseFloat(row.hvac_1_area) * parseFloat(row.hvac1_ceil_ht)  ) + ( parseFloat(row.hvac_2_area)* parseFloat(row.hvac2_ceil_ht) ) + ( parseFloat(row.hvac_3_area) * parseFloat(row.hvac3_ceil_ht) ) + (parseFloat(row.hvac_4_area) * parseFloat(row.hvac4_ceil_ht) ) ) + parseFloat(row.addvol) }}<small style="padding-left: 2px">ft<sup>3</sup></small>
              </div>
            </td>

            <td>
              <div>
                #1 {{row.heightarea1}} <hr>
                #2 {{row.heightarea2}}
              </div>
            </td>

            <td>
            </td>
          </ng-template>
        </ngx-table>






<ng-template #loadingTemplate>
  <td [attr.colspan]="columns.length">
    <div style= "width: 100%; text-align: center">
      <div style="display: inline-block; margin: auto; padding: 3px">
          <div class="lds-ripple"><div></div><div></div>Loading...</div>
      </div>
    </div>
  </td>
</ng-template>

